export function thousandSeperator(x: number | string | null | undefined) {
    if (x === null || x === undefined || x === "") {
        return "0";
    }

    const rawValue = `${x}`.replace(/,/g, "").trim();

    if (!rawValue) {
        return "0";
    }

    const sign = rawValue.startsWith("-") ? "-" : "";
    const unsignedValue = sign ? rawValue.slice(1) : rawValue;
    const [integerPart = "0", decimalPart] = unsignedValue.split(".");

    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return `${sign}${formattedInteger}${decimalPart !== undefined ? `.${decimalPart}` : ""}`;
}

export function fourDigitSeperator(x: number | string) {
    return x.toString().replace(/\B(?=(\d{4})+(?!\d))/g, ' ');
}
